import {BaseColumn} from './base-column.model';

export class ButtonColumn extends BaseColumn {
  type: 'details' | 'edit' | 'delete' | 'download';

  constructor(title: string,
              config: ButtonColumnConfig) {
    super(title,
      {
        property: null,
      });
    this._columnType = 'ButtonColumn';
    this.type = config.type;
  }

  get(element: any): any {
    return this.type;
  }
}

export interface ButtonColumnConfig {
  type: 'details' | 'edit' | 'delete' | 'download';
}
